import { TableColumn } from 'react-data-table-component';
import { ScoreBoardData } from '../../../types/Scoring';
import { TFunction } from 'i18next';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { formatWithOffset } from '../../../lib/timeUtils';

export const createLessonColumns = (
  pageLang: string,
  t: TFunction,
  viewerTz: string,
  lessonColumns: ScoreBoardData['columns'],
): TableColumn<ScoreBoardData['rows'][0]>[] => {
  return lessonColumns
    .filter((col) => col.lessonId)
    .map((col) => {
      const lessonId = col.lessonId!;
      const columnKey = `lesson_${lessonId}` as const;
      const lessonTitle =
        pageLang === 'en' ? col.title : col.translations?.find((tr) => tr.lang === pageLang)?.title;

      return {
        name: (
          <div className="text-center ">
            <div
              className="font-weight-bold"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {lessonTitle}
            </div>
          </div>
        ),
        selector: (row) => row[columnKey]?.display || 'No data',
        sortable: false,
        sortField: columnKey,
        center: true,
        cell: (row) => {
          const lessonDisplay = row[columnKey];
          if (!lessonDisplay)
            return (
              <span className="text-muted w-100 text-center">{t('scoring.totalTable.noData')}</span>
            );

          // Get detailed scoring data from scoringByLesson

          const scoringData = row.scoringByLesson[lessonId];
          const scoringList = scoringData?.scoringList || [];
          console.log('Scoring data for lesson', lessonId, scoringData);
          // const getScoreColor = (score: number | null) => {
          //   if (score === null) return 'text-muted';
          //   if (score >= 90) return 'text-success';
          //   if (score >= 70) return 'text-warning';
          //   return 'text-danger';
          // };
          const grouped = scoringData?.groupedByExam ?? []; // нове поле
          const haveGroups = grouped && grouped.length > 0;
          console.log('Grouped scoring data', { grouped, haveGroups });
          // const getScoreBackground = (score: number | null) => {
          //   if (score === null) return 'bg-light';
          //   if (score >= 90) return 'bg-success-light';
          //   if (score >= 70) return 'bg-warning-light';
          //   return 'bg-danger-light';
          // };

          // Generate unique tooltip ID for this cell
          const toolTipId = `scoring-tooltip-${row.key}-${lessonId}`;

          return (
            <>
              <div
                className={`d-flex w-100 justify-content-between align-items-center text-start p-2 `} // ${getScoreBackground(lessonDisplay.totalExamsScore)}
              >
                <div
                  id={toolTipId}
                  className={`font-weight-bold w-100 text-center `} //${getScoreColor(lessonDisplay.totalExamsScore)}
                >
                  {/* {lessonDisplay.display} */}
                  {
                    <span>
                      {lessonDisplay.display.startsWith('no')
                        ? t(`scoring.totalTable.${lessonDisplay.display}`)
                        : lessonDisplay.display}
                    </span>
                  }
                </div>
                {/* {lessonDisplay.hasUnscored && (
                    <small className="text-danger">
                      <i className="fa fa-exclamation-triangle" /> Unscored
                    </small>
                  )} */}
                {(scoringList.length > 0 || scoringData) && (
                  <>
                    {/* <Button
                      id={toolTipId}
                      size="xs"
                      color="primary"
                      className="me-0 ms-1"
                      style={{ padding: '2px 6px', fontSize: '10px' }}
                    >
                      <i className="fa fa-info-circle" />
                    </Button> */}
                    <UncontrolledTooltip
                      target={toolTipId}
                      placement="left"
                      container="body"
                      delay={{ show: 50, hide: 50 }}
                      style={{
                        minWidth: '120px',
                        maxWidth: '500px',
                      }}
                      className="avg-tooltip"
                    >
                      <div className="d-flex flex-column text-start">
                        <h6 className="mb-2">{t('scoring.totalTable.scoringDetails')}</h6>

                        {/* Basic stats */}
                        {/* <div className="mb-2">
                            <strong>{t('scoring.totalTable.generated')}:</strong>{' '}
                            {scoringData?.totalExamsGenerated || 0}
                            <br />
                            <strong>{t('scoring.totalTable.scored')}:</strong>{' '}
                            {scoringData?.totalScoringsQty || 0}
                            <br />
                            <strong>{t('scoring.totalTable.hasUnscored')}:</strong>{' '}
                            {scoringData?.hasUnscored ? t('global.yes') : t('global.no')}
                          </div> */}

                        {/* Scoring history */}
                        {haveGroups && (
                          <>
                            {/* <hr className="my-2" /> */}
                            {/* <h6 className="mb-2">{t('scoring.totalTable.scoringHistory')}</h6> */}
                            <div style={{ height: '100%', overflowY: 'auto' }}>
                              {grouped.map((group) => (
                                <div key={group.examId} className="mb-2">
                                  <div className="fw-bold mb-1">
                                    {t('scoring.totalTable.exam', { id: group.examId })}
                                  </div>
                                  {group.attempts.length === 0 ? (
                                    <div className="text-muted small">
                                      {t('scoring.totalTable.noScoring')}
                                    </div>
                                  ) : (
                                    group.attempts.map((a, i) => (
                                      <div
                                        key={a.assistantExamId}
                                        className={`mb-1 p-1 rounded ${a.failedScoring ? 'bg-danger-light' : 'bg-light'}`}
                                      >
                                        <div className="d-flex justify-content-between text-black">
                                          <span>
                                            <p className="m-0">
                                              <strong>
                                                {t('scoring.totalTable.attemptNo', {
                                                  num: i + 1,
                                                })}
                                              </strong>
                                            </p>
                                          </span>
                                          <span
                                            className={
                                              a.failedScoring ? 'text-danger' : 'text-success'
                                            }
                                          >
                                            {a.score} {a.failedScoring && '(Failed)'}
                                          </span>
                                        </div>
                                        {a.createdAt && (
                                          <small className="text-muted">
                                            {formatWithOffset(a.createdAt, viewerTz, undefined)}
                                          </small>
                                        )}
                                      </div>
                                    ))
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {/* No scoring history message */}
                        {scoringList.length === 0 && (
                          <div className="text-muted">
                            <small>{t('scoring.totalTable.noScoring')}</small>
                          </div>
                        )}
                      </div>
                    </UncontrolledTooltip>{' '}
                  </>
                )}
              </div>
            </>
          );
        },
        width: '150px',
        minWidth: '150px',
        style: {
          borderRight: '2px solid #dee2e6',
        },
      };
    });
};
